import React from "react";
import StepIndicator from "../subComponent/step-indicator/StepIndicator";
import { SuccessAlertComponent } from "../odsCalloutBox/SuccessAlertComponent";
import { FormSectionElements, ProgramContainer } from "../../entities/formTemplateDataType";
import { EmailButtonComponent } from "../subComponent/EmailButtonComponent";
import axios from "axios";
import { Heading5 } from "../../theme";
import { WarningAlertComponent } from "../odsCalloutBox/WarningAlertComponent";
import FeedbackComponent from "../subComponent/FeedbackComponent";
import { ReactComponent as AlertIcon } from '../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-alert-information.svg';
import { FeedbackStatus } from "../../entities/Constants";
import { cleanup } from "../../security/PublicSecure";
import { handleFormBuilderLink } from "../../utilities/URLUtils";

interface Props {
    programContainer: ProgramContainer
    isEng: boolean;
    transactionId: string;
    Visible: boolean;
    callback:(p:any) =>void,
    uploadReceiptSuccess:boolean
}

export class CHCOrderConfirmationComponent extends React.Component<Props> {
   field: FormSectionElements;
    constructor(props: Props) {
        super(props);

        this.field = new FormSectionElements();
        this.field.ENUTitle = "Send transaction receipt to this email address:";
        this.field.FRATitle = "Envoi du reçu de transaction à cette adresse de courriel:";
    
        this.field.ENUDescription = "Your email address will only be used to send you a transaction receipt and will not be retained.";
        this.field.FRADescription = "Votre adresse de courriel ne sera utilisée que pour vous envoyer un reçu de transaction et ne sera pas conservée.";
    }

    downloadReceipt(transId: string) {
        const url = process.env.DOWNLOAD_RECEIPT_URL.replace("{transactionID}", transId);
        fetch(url).then(resp => resp.arrayBuffer())
        .then(buf => {
            const blob = new Blob([buf], { type: "application/pdf" });
            const anchor = document.createElement("a");

            anchor.href = window.URL.createObjectURL(blob);
            anchor.download = `Receipt-${transId}`;
            anchor.hidden=true;

            document.body.append(anchor);
            anchor.click();
            anchor.remove();

            // in case the Blob uses a lot of memory
            window.addEventListener(
                "focus",
                () => {
                URL.revokeObjectURL(anchor.href);
                },
                {
                once: true,
                }
            )
        });
    }

    render() {
        if (!this.props.Visible) return null;

        const profile = this.props.programContainer.Profile;
        let backToLabel;
        let backToUrl;
        let body;
        if (profile && profile.email) {
             backToLabel = this.props.isEng ? "Back to home" : "Retour à l'accueil";
             backToUrl = process.env.PUBLIC_CXP_WEB_BASE_PATH + '/auth/signin?redirectUri='  + (this.props.isEng ? '' : '/fr') + '/dashboard';
            body = this.props.isEng ? "A confirmation receipt will be sent to your inbox." : "Un message de confirmation sera envoyé à votre boîte de réception."
        } 
        
         else {
             backToLabel = this.props.isEng ? "Back to Ontario.ca" : "Revenir à Ontario.ca";
             backToUrl = this.props.isEng ? "https://www.ontario.ca/page/government-ontario" : "https://www.ontario.ca/fr/page/gouvernement-de-lontario";
          //   feebackUrl = this.props.isEng ? process.env.FEEDBACK_URL_NO_CXP_USER : process.env.FEEDBACK_URL_NO_CXP_USER_F;
         }


        const alertTitle = this.props.isEng ? "The child health card renewal application has been submitted"
        : "La demande de renouvellement de la carte Santé de l’enfant a été soumise";
        const isReceiptUploaded:boolean = this.props.uploadReceiptSuccess;
        
        return (
            <div>
                <div>
                    <StepIndicator withbackbtn={true} sectionSequence={-1} title={backToLabel} programContainer={this.props.programContainer}
                         isEng={this.props.isEng}
                        callback={(currentStep) => { this.setState({ stepperIndex: currentStep }) }}>
                    </StepIndicator>
                </div>

                <div>
                    {isReceiptUploaded ? 
                    <SuccessAlertComponent field={this.field}
                        title={alertTitle}
                        bodyMsg={body}
                        isEng={this.props.isEng} Visible={isReceiptUploaded} /> 
                        : 
                        <WarningAlertComponent title={alertTitle} bodyMsg={this.props.isEng ? "Due to a technical issue, we were unable to generate your downloadable receipt. Please keep a record of your order ID and contact ServiceOntario if you do not receive the health card in 4-6 weeks." : "En raison d'un problème technique, nous n'avons pas pu générer votre reçu téléchargeable. Veuillez conserver une trace de votre identifiant de transaction et contacter ServiceOntario si vous ne recevez pas la carte Santé dans un délai de 4 à 6 semaines."}  isEng={this.props.isEng}
                         Visible={!isReceiptUploaded}/> }
                    
                </div>

                <div>
                    <span className="ontario-h1">{this.props.isEng ? "Your renewal application has been submitted" :
                        "La demande de renouvellement de la carte Santé de l’enfant a été soumise"}</span>
                </div>
                <p></p>
                <div>
                    <span className="ontario-h5">{this.props.isEng ? "Order ID: " + this.props.transactionId :
                        "ID de la commande :" + this.props.transactionId}</span>
                </div>
                <p></p>
                <div>
                    {/* <button className="ontario-button ontario-button--primary"disabled={!isReceiptUploaded} onClick={() => {
                        const url = process.env.DOWNLOAD_RECEIPT_URL.replace("{transactionID}", this.props.transactionId);
                        window.open(url, '_blank');
                    }}>{this.props.isEng ? "Download PDF receipt" : "Télécharger le reçu PDF"}</button> */}
                    <button className="ontario-button ontario-button--primary confirmation-button"disabled={!isReceiptUploaded} onClick={() => this.downloadReceipt(this.props.transactionId)}>
                        {this.props.isEng ? "Download PDF confirmation" : "Télécharger la confirmation en PDF"}
                    </button>
                </div>
                <div>
                    <button className="ontario-button ontario-button--secondary confirmation-button" onClick={() => {
                        cleanup(this.props.programContainer.CategoryId.toLowerCase(), this.props.programContainer);
                        window.location.replace(backToUrl);
                    }}>
                        {backToLabel}
                    </button>
                </div>
                <div style={{display: 'flex', alignItems: 'flex-start'}} className="ontario-margin-bottom-32-!">
                    <AlertIcon style={{width: '36px', height: '36px', marginRight: '0.5rem', marginTop: '-0.25rem'}}/>
                    {this.props.isEng && !this.props.programContainer.Profile?.userId && (
                        <span>IMPORTANT: Check your downloaded files before closing this screen. You will not be able to access your confirmation here again.</span>
                    )}
                    {this.props.isEng && this.props.programContainer.Profile?.userId && (
                        <span>Note: Check your downloaded files before closing this screen.</span>
                    )}
                    {!this.props.isEng && !this.props.programContainer.Profile?.userId && (
                        <span>IMPORTANT : Vérifiez vos fichiers téléchargés avant de fermer cet écran. Vous ne pourrez plus accéder à votre confirmation ici.</span>
                    )}
                    {!this.props.isEng && this.props.programContainer.Profile?.userId && (
                        <span>Remarque : Vérifiez vos fichiers téléchargés avant de fermer cet écran.</span>
                    )}
                </div>
                <div>
                    <div style={{ display: profile && profile.userId ? "none" : "block",...(!isReceiptUploaded && {pointerEvents:'none',opacity:0.5}) }} >
                        <EmailButtonComponent key={"EmailComponent"}
                            field={this.field} editable={true}
                            disabled={!isReceiptUploaded}
                            title={this.props.isEng ? <Heading5>{this.field.ENUTitle}</Heading5> : <Heading5>{this.field.FRATitle}</Heading5>}
                            labelControlArray={null} requiredField={false}
                            isEng={this.props.isEng}
                            callback={(field) => {
                                console.log(field)
                                const payload = {
                                    "to": field.Value,
                                    "transactionId": this.props.transactionId,
                                    "language": this.props.isEng ? "EN" : "FR"
                                }
                                const url = process.env.EMAIL_URL;
                                axios.post(url, payload)
                                    .then(
                                        (res) => {
                                            console.log(res)
                                        }
                                    )
                                    .catch(ex => {
                                        console.log(ex);
                                    })
                            }}>
                        </EmailButtonComponent>
                    </div>

                    <div>
                        <p></p>
                        <span className="ontario-h2">{this.props.isEng ? "What to do next" : "Que faire ensuite"}</span>
                    </div>
                    <div>
                        <ul>
                            <li>{this.props.isEng ? "keep your receipt" : "Conservez votre reçu"}</li>
                            <li>{this.props.isEng ? "You can now check the status of your online Child Health Card Renewal application here:" : "You can now check the status of your online Child Health Card Renewal application here: "}
                                <a href="/on-form/#/chc-status" onClick={handleFormBuilderLink}>cxp.mgcs.gov.on.ca</a>.
                            </li>
                            <li>{this.props.isEng ? "Please continue to use your child's existing health card until the process is completed. If the application is successful, the renewed card will be mailed to you in approximately 4 to 6 weeks. If you do not receive your card within 6 weeks of your application’s effective date, visit or contact "
                                : "Veuillez continuer d'utiliser la carte Santé existante de votre enfant jusqu'à la réception de la nouvelle par la poste. La carte renouvelée vous sera envoyée par la poste dans environ quatre à six semaines. Si vous n'avez pas reçu votre carte dans les six semaines suivant la date d'entrée en vigueur de votre demande, visitez ou contactez "}
                                <a href={this.props.isEng ? "https://www.ontario.ca/page/government-ontario" : "https://www.ontario.ca/fr/page/gouvernement-de-lontario"}>ServiceOntario</a>.
                            </li>
                        </ul>
                    </div>
                    <div>
                        <FeedbackComponent 
                            programContainer={this.props.programContainer}
                            isEng={this.props.isEng}
                            transactionId={this.props.transactionId}
                            status={FeedbackStatus.Success}
                        />
                    </div>
                </div>
            </div>
        )
    }
}